import PropTypes from "prop-types";
import content from "app-content";
import styles from "./index.css";
import clientConfigurationProvider from "../../../../providers/clientConfigurationProvider";
import { SEE_SIMILAR } from "../../../../../constants";

const SeeSimilarButton = ({ productId, isDisabled }) => {
  const { siteRootPath } = clientConfigurationProvider();

  return isDisabled ? (
    <span className={styles.seeSimilarButton}>
      {content.saved_items_web_similar_items_button}
    </span>
  ) : (
    <a
      href={`${siteRootPath}${SEE_SIMILAR}/${productId}`}
      className={styles.seeSimilarButton}
    >
      {content.saved_items_web_similar_items_button}
    </a>
  );
};

SeeSimilarButton.propTypes = {
  productId: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired
};

export default SeeSimilarButton;
